export { default } from "./withAdminContentPrivileges";
